/* eslint-disable eqeqeq */
import _ from 'underscore';

import { Cookies } from '@trello/cookies';
import { isShortLink } from '@trello/id-cache';
import type { RouteId } from '@trello/router';
import { getRouteParamsFromPathname } from '@trello/router';
import { navigate } from '@trello/router/navigate';
import { importWithRetry } from '@trello/use-lazy-component';

import { renderTopLevelComponent } from 'app/scripts/controller/renderTopLevelComponent';
import { Auth } from 'app/scripts/db/Auth';
import { LazyTemplatesContainer } from 'app/src/components/Templates';
import { controllerEvents } from './controllerEvents';

export const templatesGalleryPublicPage = function () {
  const routeParams = getRouteParamsFromPathname<
    typeof RouteId.TEMPLATES | typeof RouteId.TEMPLATES_RECOMMEND
  >(window.location.pathname);
  const templateSlug = routeParams.templateSlug;
  const category = routeParams.category;
  const referrerUsername =
    'referrerUsername' in routeParams ? routeParams?.referrerUsername : null;
  let shortLink;
  if (Auth.isLoggedIn()) {
    shortLink = _.last(templateSlug != null ? templateSlug.split('-') : []);
    if (templateSlug && (shortLink == null || !isShortLink(shortLink))) {
      navigate('/templates', { replace: true, trigger: true });
      return;
    }
    const opts = {
      titleKey: 'templates',
      orgname: null,
      showHomeBoardsTab: false,
      templatesData: {
        category,
        templateSlug,
        shortLink,
        referrerUsername,
        isInAppGallery: true,
      },
    };
    return importWithRetry(
      () =>
        import(/* webpackChunkName: "member-home-page" */ './memberHomePage'),
    ).then(({ memberHomePage }) => {
      // @ts-expect-error TS(2345): Argument of type '{ titleKey: string; orgname: nul... Remove this comment to see the full error message
      memberHomePage.call(this, opts);
      return;
    });
  }
  if (referrerUsername) {
    Cookies.set(
      'referrer',
      referrerUsername,
      { path: '/', expires: 14 },
      'necessary',
    );
  }
  shortLink = _.last(templateSlug != null ? templateSlug.split('-') : []);
  // setViewType sets @currentModel to null. This is so that when we navigate
  // to templates from a board things like board headers don't hang around
  controllerEvents.trigger('setViewType', 'blank');

  if (templateSlug && (shortLink == null || !isShortLink(shortLink))) {
    navigate('/templates', { replace: true, trigger: true });
    return;
  }

  // we are retiring the /templates/all endpoint
  if (category && category === 'all' && !shortLink) {
    navigate('/templates', { replace: true, trigger: true });
    return;
  }

  return renderTopLevelComponent(
    <LazyTemplatesContainer
      category={category}
      shortLink={shortLink}
      isInAppGallery={false}
    />,
  );
};
